import { render } from "./HomeContact.html?vue&type=template&id=97ade4ee&scoped=true&ts=true&external"
import script from "./HomeContact.ts?vue&type=script&lang=ts&external"
export * from "./HomeContact.ts?vue&type=script&lang=ts&external"

import "./HomeContact.scss?vue&type=style&index=0&id=97ade4ee&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ade4ee"]])

export default __exports__